import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {ClientsUnit, ClientsUnitsFilters, ClientsUnitUI} from '@store/clients/units/clients-units.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface ClientsUnitsState {
  status?: GlobalStatus;
  filters: ClientsUnitsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const clientsUnitsStore = createStore(
  {name: 'clients-units'},
  withProps<ClientsUnitsState>({
    status: undefined,
    filters: {search: '', tableFilters: ClientsUnitsFilters.initTableFilters()},
    sort: {
      field: 'organisationUnit.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<ClientsUnit>(),
  withUIEntities<ClientsUnitUI>(),
  withPagination(),
  withRequestsStatus(),
);